import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaVideo, FaPlay, FaBan, FaCheckDouble } from 'react-icons/fa';

const ConferenceSubNav = ({ type }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Determine base path based on conference type
    const basePath = type === 'paid' ? '/reporter/paidconference' : '/reporter/freeconference';

    const navItems = [
        {
            id: 'new',
            label: 'New',
            path: `${basePath}/new`,
            icon: FaVideo,
            activeColor: 'bg-blue-600',
            activeShadow: 'shadow-blue-200'
        },
        {
            id: 'accepted',
            label: 'Active',
            path: `${basePath}/accepted`,
            icon: FaPlay,
            activeColor: 'bg-green-600',
            activeShadow: 'shadow-green-200'
        },
        {
            id: 'rejected',
            label: 'Denied',
            path: `${basePath}/rejected`,
            icon: FaBan,
            activeColor: 'bg-rose-600',
            activeShadow: 'shadow-rose-200'
        },
        {
            id: 'completed',
            label: 'Done',
            path: `${basePath}/completed`,
            icon: FaCheckDouble,
            activeColor: 'bg-purple-600',
            activeShadow: 'shadow-purple-200'
        }
    ];

    return (
        <div className="sticky top-2 sm:top-4 lg:top-6 z-40 mb-4 sm:mb-6 flex justify-center px-1 sm:px-0 pointer-events-none">
            {/* Pointer events none on wrapper so we don't block clicks beneath the sticky gap, but auto on the actual pill */}
            <div className="bg-white/90 backdrop-blur-xl shadow-xl shadow-slate-200/40 border border-slate-100 rounded-[1.5rem] sm:rounded-full p-1.5 sm:p-2 w-full sm:w-auto mx-auto pointer-events-auto transition-all">
                <div className="flex justify-between sm:justify-center items-center gap-1 sm:gap-2 w-full">
                    {navItems.map((item) => {
                        const isActive = location.pathname.includes(item.path);
                        const Icon = item.icon;

                        return (
                            <button
                                key={item.id}
                                onClick={() => navigate(item.path)}
                                className={`
                                    flex-1 sm:flex-none sm:min-w-[120px] md:min-w-[140px] flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2.5 
                                    py-1.5 sm:py-2.5 rounded-xl sm:rounded-full transition-all duration-300
                                    ${isActive
                                        ? `${item.activeColor} text-white shadow-md ${item.activeShadow} scale-[1.02]`
                                        : 'bg-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-700 active:scale-95'
                                    }
                                `}
                            >
                                <div className={`
                                    w-5 h-5 sm:w-7 sm:h-7 flex items-center justify-center rounded-[0.4rem] sm:rounded-full transition-colors shrink-0
                                    ${isActive ? 'bg-white/25' : 'bg-slate-100 group-hover:bg-slate-200'}
                                `}>
                                    <Icon className={`w-3 h-3 ${isActive ? 'text-white drop-shadow-sm' : 'text-slate-500'}`} />
                                </div>
                                <span className={`text-[9px] sm:text-xs font-black uppercase tracking-widest whitespace-nowrap ${isActive ? 'text-white' : 'text-slate-600'}`}>
                                    {item.label}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ConferenceSubNav;
